import styled, { ThemeProps } from '@themes/theme'
import { css } from '@emotion/core'

export const ToggleBtnStyle = (props: ThemeProps) => css`
  .setting-input {
    position:absolute;
    left: 0;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    border: 0;
    clip: rect(0, 0, 0, 0);
    & + .on-off-wrap {
      position:relative;
      display: block;
      width: 70px;
      height: 28px;
      line-height: 3rem;
      border-radius: 50px;
      background:  ${props.theme.color.btn};
      transition: all .3s;
      &::after {
        content:'';
        position: absolute;
        top:50%;
        left:3px;
        display: block;
        width:23px;
        height:23px;
        border-radius: 50%;
        background:  ${props.theme.color.themeTxt};
        transform: translate(0,-50%);
        transition: all .3s;
      }
      .on, .off {
        position: relative;
        font-size:  ${props.theme.font.large};
      }
      .on {
        display: none;
        float: left;
        margin-left: 16px;
        background: linear-gradient(to bottom, rgb(255,255,255), rgb(193,240,245));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .off {
        display: block;
        float: right;
        margin-right: 12px;
        background: linear-gradient(to bottom, rgb(255,255,255), rgb(202,209,217));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    &:checked + .on-off-wrap  {
      background: ${props.theme.color.primaryBg};
      .on {
        display: block;
      }
      .off {
        display: none;
      }
      &::after {
        transform: translate(180%, -50%);
      }
    }
    &.no-txt {
      & + .on-off-wrap {
        width: 34px;
        height: 18px;
        box-shadow: inset 1px 1px 2px #00000061, 0 1px 1px #50607033;
        background: ${props.theme.color.mainBg};
        &::after {
          width: 14px;
          height: 14px;
          background: ${props.theme.color.disableTxt};
          left: 2px;
        }
      }
      &:checked + .on-off-wrap  {
        background: linear-gradient(135deg, #26AAB8, #257276);
        &::after {
          background: ${props.theme.color.white};
          transform: translate(115%, -50%);
        }
      }
    }
  }
`

export const ChatSettingWrap = styled.div`
  border-top: 1px solid ${props => props.theme.color.modalSubBg2};
  padding: 16px 25px;
  background: ${props => props.theme.color.themeTxt};
  .setting-list {
    &--item {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      padding: 14px 0;
      border-bottom: 1px solid ${props => props.theme.color.modalBg};
      &:last-of-type {
        //padding-bottom: 0;
        border: none;
      }
      .setting-tit {
        display: block;
        text-align: left;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
        .setting-sub-txt {
          display: block;
          margin-top: 5px; 
          color: ${props => props.theme.color.modalgray};
          font-weight: ${props => props.theme.fontW.medium};
        }
      }
      ${ToggleBtnStyle};
    }
  }
`

export const ChatSettingLabel = styled.label``
